import { z } from "zod";
export const PublicStatusComponentSchema = z.object({
    name: z.string().min(1),
    status: z.enum(["operational", "degraded", "outage"]),
    summary: z.string().min(1),
});
export const PublicStatusResponseSchema = z.object({
    status: z.enum(["operational", "degraded", "outage"]),
    generatedAt: z.string().datetime(),
    components: z.array(PublicStatusComponentSchema),
});
//# sourceMappingURL=status.js.map